import { createContext } from 'react';

export interface AppContextProps {
  betaFeaturesEnabled?: boolean;
  setBetaFeaturesEnabled?: (status: boolean) => void;
}

export const AppContext = createContext<AppContextProps>({});
